import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'


declare var jquery: any;
declare var $: any;
declare var tableau: any;

@Component({
    templateUrl: './AppViews/tablaeu/tablaeuReport.html',
    
})

export class tablaeuReportComponent implements OnInit {
  
   constErrors: any;
  messageType: any;
  spinnerVisible:any = false;
  userDetail: any; 
  public BIAccessTokenDetails : any;
  public predefinedFilter1:any;
  constants: Constants;
  public menuAccessList:any = null;
  masterSideMenu:any;
  constructor(private _httpService: HTTPService,private _sharedService: MySharedService) { }
  
  ngOnInit() {
  this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    this.constants = new Constants();
this.getSiteUserMenuAccess();
    
    //this.getAccessToken();
}


public getSiteUserMenuAccess(){
  
   var getMenuModel = {
    "ProfileId": 1,
    "MenuValueId" : 168
 }
  
  this._httpService.ajaxPost('Common/GetSiteuserMenuList',{
    "ProfileId": 1,
    "MenuValueId" : 168
 }).subscribe(
    data => {

        this.menuAccessList = data["MenuList"];
        if(this.menuAccessList.length>0)
        {
        setTimeout(() => {
          $('#tab'+this.menuAccessList[0].MenuId).addClass("active");
            this.sidePanelClick(this.menuAccessList[0]);
        }, 0);
      }
        
      
    },
    err => {
                console.log("Report Failed");
              this.hideSpinner();
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
               this.hideSpinner();
            });
 }


   public sidePanelClick(item)
   {
     if(this.viz!=null)
        this.viz.dispose();
      
       this.menuAccessList .forEach(element => {
      
      $('#'+element.MenuId).removeClass("active");  
    });
      
          $('#'+item.MenuId).addClass("active");
        this.getToken(item);
    
    
   
    
  
    //this.loadReport(item.PageUrl,item.MenuValue);

    
     //alert(item.MenuValue);
   }

getToken(MenuItem)
{
  this.spinnerVisible = true;
  this._httpService.ajaxPost('Common/GetEmbedToken', null).subscribe(
    data => {
        this.initViz(data["EmbedToken"],MenuItem);
        //this.messageService.showMessage(data["Message"].Text, this.messageType.Success);
        
   
     
    },
   err => {
                console.log("Report Failed");
            
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
           
            });
 }

 viz:any;

   initViz(token,MenuItem ) {
     var timeStamp = Math.floor(Date.now() / 1000);
   var maindiv =  document.getElementById("vizContainer");
    var containerDiv =
    document.getElementById("vizContainer")
   // ,url = "http://66.199.234.82:81/trusted/"+token+"/views/SMART3/"+"ProductionDifference/Dashboard1?:iid=1", //MenuItem.PageUrl,
    ,url = "http://smart3.emqube.com:81/trusted/"+token+"/"+MenuItem.MenuURL+"&:toolbar=no&:refresh=true&"+timeStamp,
  //,url = "http://66.199.234.82:81/trusted/"+token+"/"+MenuItem.MenuURL+"&:toolbar=no",
 
        options = {
            hideTabs: false,
            toolbar:false,
            onFirstInteractive: function () {
              //
              // this.WorkBook = this.viz.getWorkbook();
              // this.activeSheets = this.WorkBook.getActiveSheet();
                console.log("Run this code when the viz has finished loading.");
            }
        };
  
    this.viz = new tableau.Viz(containerDiv, url, options);
    // Create a viz object and embed it in the container div.
}


showSpinner() {
  setTimeout(() => {
      this.spinnerVisible = true
  }, 0);
}

hideSpinner() {
  setTimeout(() => { this.spinnerVisible = false }, 0);
}


   
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/tablaeu/tablaeuReport.component.ts
 **/